// ====================================================================
// ziven-core forum utils reactionTwemoji - reaction emoji Twemoji CDN 渲染
// ====================================================================
//
// 用途 (辉哥 2026-09-10 10:14 反馈 "现在展示的是文字, 不是像帖子里那样的图标"):
//   ziven-reactions 帖子页 PostReactionCounts 用 ReactionComponent 组件,
//   内部走 Twemoji CDN <img src="https://cdnjs.cloudflare.com/.../72x72/[codepoint].png">
//   ziven-core 列表项 reaction summary 要跟 ziven-reactions 视觉一致, 不能用 unicode 文字.
//
// 设计:
//   - 6 个 ziven-reactions 默认 reaction (thumbsup / thumbsdown / laughing / confused / heart / tada)
//     hardcode Twemoji codepoint + unicode 兜底
//   - 跨 extension 兼容: ziven-core 不 import ziven-reactions 内部组件, 也不 import simple-emoji-map,
//     直接 hardcode 6 个 codepoint (新增 reaction 需要同步更新这里, 但 ziven-reactions 默认 6 个是固定的)
//   - 未知 reaction 兜底 unicode 字符, 优雅降级
//
// 跟 ziven-reactions util/emoji.js 区别:
//   - ziven-reactions 用 simple-emoji-map + FuzzySet 模糊匹配 identifier → codepoint, 智能但重
//   - ziven-core hardcode 6 个 codepoint, 轻量够用, 跟 DiscussionReactionSummary 视觉 1:1 一致
// ====================================================================

// 跟 ziven-reactions util/emoji.js DEFAULT_CDN_URL 保持一致 (Twemoji v16.0.1)
export const TWEMOJI_VERSION = '16.0.1';
export const TWEMOJI_CDN = "https://cdnjs.cloudflare.com/ajax/libs/twemoji/".concat(TWEMOJI_VERSION, "/72x72/");

// 6 个 ziven-reactions 默认 reaction 的 Twemoji codepoint + unicode 兜底
export const REACTION_TWEMOJI = {
  thumbsup: {
    codepoint: '1f44d',
    unicode: '👍'
  },
  thumbsdown: {
    codepoint: '1f44e',
    unicode: '👎'
  },
  laughing: {
    codepoint: '1f606',
    unicode: '😆'
  },
  confused: {
    codepoint: '1f615',
    unicode: '😕'
  },
  heart: {
    codepoint: '2764',
    unicode: '❤'
  },
  tada: {
    codepoint: '1f389',
    unicode: '🎉'
  }
};
flarum.reg.add('ziiven-ziven-core', 'forum/utils/reactionTwemoji', { TWEMOJI_VERSION: TWEMOJI_VERSION,TWEMOJI_CDN: TWEMOJI_CDN,REACTION_TWEMOJI: REACTION_TWEMOJI, });